import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FamilyService {

  constructor(private http: HttpClient) {}

  getFamilyData(formsId: number): Observable<any> {
    return this.http.get(`${environment.api_guia}forms/${formsId}/spouses`);
  }

  updateFamilyData(formsId: number, familyId: number, data: any): Observable<any> {
    return this.http.patch(`${environment.api_guia}forms/${formsId}/spouses/${familyId}`, data);
  }
}
